import(/* webpackMode: "eager" */ "/app/apps/public/app/global-error.tsx");
